<template>
    <div class="home-process">
        <img class="home-process-backimg" :src="backImg" alt="">
        <div class="home-process-box">
            <p class="home-process-title">
                先乘车后支付尾款流程
            </p>
            <p class="home-process-normal">
                保时达为客户以及车队双方提供相应保障服务的承诺
            </p>

            <div class="home-process-row">
                <div class="home-process-row-list" v-for="(item, index) in processList" :key="index">
                    <div class="process-row-box">
                        <img class="process-row-icon" :src="item.iconUrl" alt="">
                        <span class="process-row-span">{{ item.text }}</span>
                    </div>
                    <div v-if="item.rightIcon" class="process-right-icon">
                        <img :src="item.rightIcon" alt="">
                    </div>
                </div>
            </div>

            <div class="process-explain">具体以车队沟通为准</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeProcess",
        data() {
            return {
                backImg: require('@/assets/images/index/public_img_processBg.png'),
                processList: [
                    {
                        iconUrl: require('@/assets/images/index/public_icon_process01.png'),
                        text: '填写需求',
                        rightIcon: require('@/assets/images/index/public_icon_pronext.png')
                    },
                    {
                        iconUrl: require('@/assets/images/index/public_icon_process02.png'),
                        text: '选择车队',
                        rightIcon: require('@/assets/images/index/public_icon_pronext.png')
                    },
                    {
                        iconUrl: require('@/assets/images/index/public_icon_process03.png'),
                        text: '联系沟通',
                        rightIcon: require('@/assets/images/index/public_icon_pronext.png')
                    },
                    {
                        iconUrl: require('@/assets/images/index/public_icon_process04.png'),
                        text: '签订合同',
                        rightIcon: require('@/assets/images/index/public_icon_pronext.png')
                    },
                    {
                        iconUrl: require('@/assets/images/index/public_icon_process05.png'),
                        text: '用车出行',
                        rightIcon: require('@/assets/images/index/public_icon_pronext.png')
                    },
                    {
                        iconUrl: require('@/assets/images/index/public_icon_process06.png'),
                        text: '服务保障'
                    }
                ]
            }
        },
    }
</script>

<style scoped>
    .home-process {
        width: 100%;
        height: 400px;
        min-width: 1200px;
        position: relative;
    }

    .home-process-backimg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
    }

    .home-process-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding-top: 42px;
    }

    .home-process-title {
        width: 500px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        color: #333;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin: 0 auto;
    }

    .home-process-normal {
        width: 500px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin: 12px auto 0;
        text-align: center;
    }

    .home-process-row {
        width: 1200px;
        margin: 70px auto 0;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .home-process-row-list {
        height: 82px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .process-row-box {
        width: 160px;
        height: 82px;
        display: flex;
        flex: 1;
        align-items: center;
        background: #FA592A;
        border-radius: 4px;
    }

    .process-row-icon {
        width: 48px;
        height: 48px;
        margin: 0 10px 0 12px;
    }

    .process-row-span {
        height: 24px;
        line-height: 24px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    .process-right-icon {
        width: 28px;
        height: 20px;
        margin-left: 11px;
        margin-right: 11px;
    }

    .process-explain {
        margin: 60px auto 0;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        color: #999999;
    }
</style>


// WEBPACK FOOTER //
// src/pages/home/components/homeProcess.vue